import React from 'react'

const Home = () => {
  return (
    <div>
    Welcome to  HomePage
    </div>
  )
}

export default Home
